<div class="row px-5 my-5" style="margin-top: 10vh !important">
	<div class="row mb-5" [ngClass]="isPlanificatrice && 'row-cols-3'">
		<!-- MESSAGERIE -->
		<app-dashboard-messaging
			class="col"
			[ngClass]="!isPlanificatrice && 'd-flex justify-content-center'"
			[listNotification]="listNotification"
			[manyNewMessages]="manyNewMessages"
		></app-dashboard-messaging>

		<!-- SOLUTION SEMAINE COURANTE -->
		<app-dashboard-solution-info
			*ngIf="isPlanificatrice"
			class="col"
			[weekNumber]="currentWeekNumber"
			(buildSolutionPlanningEmitter)="buildSolutionPlanning($event)"
			(validerPlanningEmitter)="validerPlanning($event)"
		></app-dashboard-solution-info>

		<!-- SOLUTION SEMAINE SUIVANTE -->
		<app-dashboard-solution-info
			*ngIf="isPlanificatrice"
			class="col"
			[weekNumber]="nextWeekNumber"
			(buildSolutionPlanningEmitter)="buildSolutionPlanning($event)"
			(validerPlanningEmitter)="validerPlanning($event)"
		></app-dashboard-solution-info>
	</div>

	<div
		class="row mb-5"
		[ngClass]="isPlanificatrice && 'row-cols-3'"
		*ngIf="isSAE"
	>
		<!-- RDV PRESCRIPTEUR -->
		<app-dashboard-prescriber-appointments
			class="col"
			[ngClass]="!isPlanificatrice && 'd-flex justify-content-center'"
			u
		></app-dashboard-prescriber-appointments>

		<app-dashboard-ocashe-appointments
			class="col"
			[ngClass]="!isPlanificatrice && 'd-flex justify-content-center'"
			u
		></app-dashboard-ocashe-appointments>
	</div>

	<div class="row" *ngIf="isPlanificatrice">
		<app-dashboard-stats [weekNumber]="currentWeekNumber"></app-dashboard-stats>
	</div>
</div>
